(function () {
  'use strict';

  function feedback($cookies, Restangular, $http, Configuration) {
    var link = function ($scope) {
      $scope.feedbacks = [];
      $scope.otherComment = {};

      $scope.onSelect = function (answer, outerIndex) {
        if (angular.isFunction($scope.onSelectCallback)) {
          $scope.onSelectCallback(answer, outerIndex);
        }
      };

      Restangular.one('feedbacks').getList('', {
        type: $scope.type
      }).then(function (questions) {
        let otherQuestion = questions[0].answers.filter(item => item.text === 'Other');
        let answers = questions[0].answers.filter(item => item.text !== 'Other');
        answers = answers.sort(() => (Math.random() - 0.5)); // randomize answers
        // if we have "other" question put it on the end
        questions[0].answers = answers.concat(otherQuestion);

        $scope.feedbackQuestions = questions;
        if ($scope.preselected) {
          $scope.feedbacks.push({
            id: questions[0].answers[0].id
          });
        }
      });

      $scope.$watch('trigger', function (triggerValue) {
        if (triggerValue) {
          post($scope.feedbacks);
        }
      });

      $scope.$watch('feedbacks', function (feedbacks) {
        if ($scope.autoTrigger) {
          post(feedbacks);
        }
      }, true);

      function post(feedbacks) {
        feedbacks.forEach(function (feedback) {
          if (!feedback || !feedback.id) {
            return;
          }

          var postArray = {
            answerId: feedback.id
          };

          if ($scope.task) {
            postArray.subjectId = $scope.task.id;
            postArray.subjectType = 'Task';
          }

          if (feedback.details) {
            postArray.details = feedback.details;
          }

          var requestUrl = $scope.anonymous ? 'anonymous_feedbacks' : 'feedbacks';

          $http
            .post(`${Configuration.apiUrl}/${requestUrl}`, postArray)
            .then(function () {
            })
            .catch(function (err) {
              console.log(err)
            })

          /* What's "heap", "feedbackObj" ???
          if (window.heap) {
            heap.addUserProperties({
              tracked_segment: feedbackObj[postArray.answerId]
            });
          }
          */

          if ($scope.onFeedbackPosted) {
            $scope.onFeedbackPosted();
          }
        });
      }
    };

    return {
      restrict: 'E',
      templateUrl: require('../../views/directives/feedback.html'),
      scope: {
        type: '@',
        task: '=',
        trigger: '=',
        autoTrigger: '=',
        onFeedbackPosted: '&',
        anonymous: '=',
        preselected: '=',
        onSelectCallback: '=',
        otherComment: '='
      },
      link: link
    };
  }

  app.directive('feedback', ['$cookies', 'Restangular', '$http', 'Configuration', feedback]);
})();
